<template>
  <div class="bottomsheet">
    <div class="bottomsheet__left" :class="{'hide-on-mobile': hideLeftOnMobile}">
      <slot name="left"></slot>
    </div>
    <div class="bottomsheet__center">
      <slot name="center"></slot>
    </div>
    <div class="bottomsheet__right" :class="{'hide-on-mobile': hideRightOnMobile}">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomSheet',
  props: {
    hideLeftOnMobile: {
      type: Boolean,
      default: true,
    },
    hideRightOnMobile: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.bottomsheet {
  position: sticky;
  bottom: 0;
  display: flex;
  background: var(--color-light);
  border-top: solid 3px var(--color-dark);
  color: var(--color-dark);
  padding: 20px 30px;
  align-items: center;
  z-index: 2;
  > div {
    flex: 1;
    display: flex;
    &:nth-child(2) {
      justify-content: center;
    }
    &:nth-child(3) {
      justify-content: flex-end;
    }
  }
  @media all and (max-width: 700px) {
    position: fixed;
    width: 100%;
    padding: 10px;
    div.hide-on-mobile {
      display: none;
    }
  }
}
</style>
